module.exports = __webpack_public_path__ + "static/media/PDF3.707654f1.pdf";